import { useEffect, useState } from "react";
import { siderBar } from "../constants/sidebar";
import Fade from "react-reveal/Fade";
import useWindowDimensions from "../controllers/useWindowDimensions";
import {BiSolidLogOutCircle} from "react-icons/bi";
import {AiFillCloseCircle} from 'react-icons/ai';
import {HiMenu} from 'react-icons/hi';
import { useLocation, useNavigate } from "react-router-dom";
export default function Sidebar() {
  const { width, height } = useWindowDimensions();
  const {pathname}=useLocation();
  const [hide, setHide] = useState(false);
  const [item, setItem] = useState();
  const navigate=useNavigate();
  useEffect(() => {
    if (width < 1400) setHide(true);
    else
    setHide(false)
  }, [width]);
  useEffect(()=>{
 setItem(pathname)
  },[pathname])
  const logout=()=>{
    localStorage.clear();
    navigate("/")
  }
if(!hide)
  return (
    <Fade left>
      <div className={`bg-[#2e3c43] p-4 rounded-r-lg h-[100vh] ${width<1400?'fixed z-10':''}`}>
        <AiFillCloseCircle  className="fill-white scale-150 float-right cursor-pointer" onClick={()=>setHide(true)}/>
        <br/>
        {siderBar.map((el) => {
          return (
            <div
              key={el.label}

              className={`flex font-Roboto font-bold space-x-4 ${item===el.path?'bg-[#3399ef]':''} p-4 pr-20  rounded-lg cursor-pointer`}
              onClick={() => {setItem(el.path); navigate(el.path);}}
            >
              {el.icon}
              <div className="text-white tracking-wider">{el.label}</div>
            </div>
          );
        })}
        <p className="font-Roboto font-bold text-gray-300 ml-2 mt-10 mb-4">Auth Page</p>
        <div className="flex font-Roboto font-bold space-x-4 cursor-pointer" onClick={logout}>
            <BiSolidLogOutCircle  className="fill-white scale-125"/>
            <div className="text-white tracking-wider">Logout</div>
        </div>
      </div>
    </Fade>
  );
  else
  return <HiMenu className="scale-150 cursor-pointer fill-[#2e3c43] fixed" onClick={()=>setHide(false)}/>
}
